export default {"src":"/_next/static/media/crab_strategy.039de52b.svg","height":33,"width":32};